import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Event } from "./event";
export default class RenderFrameEvent extends Event {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", 'renderFrame');
    _defineProperty(this, "timeStamp", void 0);
  }
}